import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Service</h1>
        
        <div className="space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Acceptance of Terms</h2>
            <p className="mb-4">
              By accessing and using our services, you accept and agree to be bound by the terms 
              and provision of this agreement. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Use License</h2>
            <p className="mb-4">
              Permission is granted to temporarily use our services for personal or commercial purposes. 
              This is the grant of a license, not a transfer of title, and under this license you may not:
            </p>
            <ul className="list-disc list-inside ml-4 mb-4 space-y-2">
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose without our written consent</li>
              <li>Attempt to reverse engineer any software contained in our services</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">3. User Account</h2>
            <p className="mb-4">
              You are responsible for maintaining the confidentiality of your account and password. 
              You agree to accept responsibility for all activities that occur under your account.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Payment Terms</h2>
            <p className="mb-4">
              If you purchase a subscription or service, you agree to pay all fees associated with 
              that service. Fees are charged in advance on a monthly or annual basis. 
              All fees are non-refundable unless otherwise stated.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Prohibited Uses</h2>
            <p className="mb-4">
              You may not use our services:
            </p>
            <ul className="list-disc list-inside ml-4 mb-4 space-y-2">
              <li>In any way that violates any applicable law or regulation</li>
              <li>To transmit any malicious code or harmful content</li>
              <li>To impersonate or attempt to impersonate another user or entity</li>
              <li>In any manner that could damage, disable, or impair our services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Service Availability</h2>
            <p className="mb-4">
              We strive to maintain service availability but do not guarantee uninterrupted access. 
              We reserve the right to modify, suspend, or discontinue any part of our services at any time.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Limitation of Liability</h2>
            <p className="mb-4">
              In no event shall we be liable for any indirect, incidental, special, consequential, 
              or punitive damages, including without limitation, loss of profits, data, or other 
              intangible losses, resulting from your use of our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Termination</h2>
            <p className="mb-4">
              We may terminate or suspend your account and access to our services immediately, 
              without prior notice, for any reason, including breach of these Terms of Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Changes to Terms</h2>
            <p className="mb-4">
              We reserve the right to modify these terms at any time. We will notify users of any 
              material changes by posting the updated terms on this page.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Contact Information</h2>
            <p className="mb-4">
              If you have any questions about these Terms of Service, please contact us at{" "}
              <a href="mailto:info@azucarmultimedia.com" className="text-blue-600 hover:text-blue-800 underline">
                info@azucarmultimedia.com
              </a>
              .
            </p>
          </section>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;

